import { bootstrap as prepareServices } from './services'
import { bootstrap as prepareDatabase } from './database'
import { bootstrap as prepareModel } from './model'
import { bootstrap as prepareStore } from './store'
import { bootstrap as prepareRouter } from './router'
import { bootstrap as prepareApi } from './api'
import { bootstrap as prepareAssets } from './assets'
import { bootstrap as prepareVendor } from './vendor'
import { bootstrap as prepareFilters } from './filters'
import { bootstrap as prepareTranslations } from './translations'

export default async () => {
  await prepareServices()
  await prepareDatabase()
  await prepareModel()
  await prepareStore()
  await prepareRouter()
  await prepareApi()
  await prepareAssets()
  await prepareVendor()
  await prepareFilters()
  await prepareTranslations()
}
